import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { ProductForReorder } from "../model/inventoryData"
import { PatchPayload } from "./types"

export class Service {
    static patch(id: string, payload: PatchPayload) {
        return AppContext.getApiClient().patch(`/inventory-data/${id}`, payload)
    }

    static async findReorderItemsForLocationID (locationId: string): Promise<ProductForReorder[]> {
        const res = await AppContext.getApiClient().get(`/products/${locationId}/reorder-items`)

        if (res.error) {
            throw new Error(res.error.message)
        } 
        const items: ProductForReorder[] = res && res.length > 0 ? res.map(product => product as ProductForReorder): []
        return items
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/data/service/service.ts